import React, { Component, Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import copy from 'clipboard-copy'
import { notify } from 'react-notify-toast'
import moment from 'moment-timezone'
import { sessionCheck } from 'src/actions/user'
import { showDialog } from 'src/actions/dialog'
import Footer from 'src/pages/Prioritize/Create/Footer'
import { getCurrentCollection, getComments } from 'src/actions/prioritize'
import CreativeView from './CreativeView'
import TabularView from './TabularView'
import {
  ExampleFactors,
  DialogModalWindow,
  Button,
  BubbleTabs,
  Timer,
  HeaderViewsToggle,
} from 'src/components/shared'
import Prioritize from '../'
import BlueHeader from '../BlueHeader'
// import Tabs from 'src/components/shared/Tabs'
import Content from './Content'
import Comments from '../Comments'
import {
  isCollectionOwner,
  splitText,
  getParticipateURL,
} from 'src/util/PrioritizeUtil'
import { GLOBAL_PATH_PREFIX } from 'src/constants'
// import authApi from 'src/api/v2/AuthApi'
import _ from 'lodash'
import collectionApi from 'src/api/v2/CollectionApi'
import './Participate.scss'
import '../Comments/Comments.scss'
import Header from '../Header'
import LoadingAndPulse from 'src/components/shared/LoadingAndPulse'

const questionsSortFunc = (a, b) => {
  if (a.title < b.title) return -1
  if (a.title > b.title) return 1
  return 0
}

class FooterButtons extends Component {
  render() {
    const {
      onClick,
      lastStep = false,
      currentTabIdx = 0,
      disabled = false,
      commentsCount,
    } = this.props
    const onClickNext = lastStep ? onClick('result') : onClick('submit')

    return (
      <Fragment>
        <div>
          <Button lg flat secondary onClick={onClick('add_comment')}>
            Add a comment
          </Button>
          <div onClick={onClick('comment')} className="comments-title mb-20">
            Comments ({commentsCount})
          </div>
        </div>

        <div>
          {currentTabIdx > 0 && (
            <Button
              disabled={disabled}
              lg
              flat
              cancel
              onClick={onClick('back')}
            >
              Back
            </Button>
          )}
          <Button disabled={disabled} lg primary submit onClick={onClickNext}>
            {lastStep ? 'Submit Rating' : 'Next'}
          </Button>
        </div>
      </Fragment>
    )
  }
}

class Participate extends Component {
  constructor(props) {
    super(props)

    this.state = {
      currentTabIdx: 0,
      isHintOpen: true,
      isShareDialogOpen: false,
      isCongratulationsDialogOpen: false,
      viewMode: 'table',
      selectedRatings: props.collection
        ? this.initSelectedRatings(props.collection)
        : {},
      displayCommentsOption: null,
      availableTabs: props.collection
        ? this.getAvailableTabs(props.collection)
        : [],
    }
  }

  // collection.children[0].questions[0].responses[0].vote.user_vote
  initSelectedRatings = (collection) => {
    const { children = [] } = collection
    const selectedRatings = {}

    children.forEach((child, tabIdx) => {
      const { questions = [] } = child
      const currentTabId = children[tabIdx].id

      questions.forEach((question, questionIdx) => {
        const { responses = [] } = question
        const currentQuestionsId = questions[questionIdx].id
        const responseWithVotes = responses.find(
          ({ vote }) => vote && vote.user_vote
        )

        if (responseWithVotes) {
          if (!selectedRatings[currentTabId]) selectedRatings[currentTabId] = {}
          selectedRatings[currentTabId][currentQuestionsId] =
            responseWithVotes.id
        }
      })
    })
    return selectedRatings
  }

  getAvailableTabs = (collection) => {
    let availableTabs = Object.entries(this.initSelectedRatings(collection))
      .filter(
        ([key, answers]) =>
          Object.keys(answers).length === collection.questions.length
      )
      .map(([key, answers]) => key)
      .map((availableTabId) =>
        collection.children.findIndex((child) => child.id === availableTabId)
      )
      .map((availableTabIdx) => `${availableTabIdx}`)

    if (
      availableTabs.length &&
      availableTabs.length !== collection.children.length
    )
      availableTabs.push(`${+availableTabs[availableTabs.length - 1] + 1}`)

    if (!availableTabs.includes('0')) availableTabs.splice(0, 0, '0')

    return availableTabs
  }

  handleClick = (id) => {
    const { children } = this.props.collection
    this.setState({
      currentTabIdx: children.findIndex((elem) => elem.id === id),
    })
  }

  toVoteType = ({
    id,
    title,
    numeric_value,
    description,
    collection_id,
    question_id,
  }) => ({
    title,
    description,
    vote_type: 'rating',
    vote_numeric_value: numeric_value,
    vote: true,
    collection_id: collection_id,
    question_id: question_id,
    response_id: id,
  })

  toIdVotesMap = (questions) => ([questionId, qColumnId]) => {
    const currentResponse = questions
      .find((q) => q.id === questionId)
      .responses.find((res) => res.id === qColumnId)
    const vote = this.toVoteType(currentResponse)
    return { id: currentResponse.id, vote }
  }

  onSubmitVotes = async () => {
    try {
      const { selectedRatings, currentTabIdx, availableTabs } = this.state
      const { collection, getCurrentCollection } = this.props
      const currentTab = collection.children[currentTabIdx]
      if (!currentTab.questions) return

      if (currentTabIdx === collection.children.length - 1) {
        this.setState({ isCongratulationsDialogOpen: true })
      }

      // console.log('currentTab, currentFactors', currentTab, currentFactors);
      const responseIdsVotesMap = Object.entries(
        selectedRatings[currentTab.id]
      ).map(this.toIdVotesMap(currentTab.questions))
      const newIndex =
        currentTabIdx + 1 < collection.children.length
          ? currentTabIdx + 1
          : currentTabIdx
      const newAvailableTabs = Array.from(
        new Set([...availableTabs, `${newIndex}`])
      )
      this.setState({
        currentTabIdx: newIndex,
        availableTabs: newAvailableTabs,
      })

      const votesPromises = responseIdsVotesMap.map(({ id, vote }) =>
        collectionApi.vote(vote)
      )
      await Promise.all(votesPromises)

      const collectionDetails = await collectionApi.get({ id: collection.id })
      getCurrentCollection(collectionDetails)
    } catch (error) {
      console.log('error', error)
    }
  }

  onComment = (action) => {
    this.setState({ displayCommentsOption: action })
  }

  loadComments = () => {
    const { collection, setComments, comments } = this.props
    const currentChild = collection.children[this.state.currentTabIdx]

    if (!currentChild || !currentChild.id) return

    collectionApi.getComments(currentChild.id).then((fetchedComments) => {
      setComments({ ...comments, [currentChild.id]: fetchedComments })
    })
  }

  updateState = () => {
    const { collection, history, location } = this.props;

    if (!collection) return

    const hasSessionEnded =
      collection.end_on &&
      moment(collection.end_on).diff(moment(), 'minute') <= 0
    if (!isCollectionOwner(collection) && !!hasSessionEnded)
      history.push(`${location.pathname}/result`)

    const selectedRatings = this.initSelectedRatings(collection)
    const availableTabs = this.getAvailableTabs(collection)
    if (!this.state.availableTabs.length) this.setState({ availableTabs })

    if (!_.isEmpty(selectedRatings) && _.isEmpty(this.state.selectedRatings))
      this.setState({ selectedRatings, hasSessionEnded })
  }

  componentDidMount = () => {
    this.updateState()
  }

  componentDidUpdate = () => {
    this.updateState()
  }

  onFooterButtonClick = (buttonType) => () => {
    const { history, location } = this.props
    const { currentTabIdx, displayCommentsOption } = this.state
    const newIndex = currentTabIdx - 1 >= 0 ? currentTabIdx - 1 : currentTabIdx
    const id = location.pathname.split('/').pop() || ''
    const pathForEdit = `${GLOBAL_PATH_PREFIX}/p/${id}/edit/factors`

    const mapActionToFunction = {
      comment: () => this.onComment(!!displayCommentsOption ? null : 'add'),
      add_comment: () => this.onComment('add'),
      back: () => this.setState({ currentTabIdx: newIndex }),
      submit: () => this.onSubmitVotes(),
      result: () => this.onSubmitVotes(),
      edit: () => history.push(pathForEdit),
    }

    const targetFunction = mapActionToFunction[buttonType] || (() => {})
    targetFunction()
  }

  onViewModeChange = (viewMode) => () => {
    this.setState({ viewMode })
  }

  onRatingClick = (rowId, columnId) => {
    const { selectedRatings, currentTabIdx } = this.state
    const currentTabId = this.props.collection.children[currentTabIdx].id
    let currentTabSelectedratings = { ...selectedRatings[currentTabId] }

    if (!currentTabSelectedratings) currentTabSelectedratings = {}
    currentTabSelectedratings[rowId] = columnId
    this.setState({
      selectedRatings: {
        ...selectedRatings,
        [currentTabId]: currentTabSelectedratings,
      },
    })
  }

  memoizeResponse = () => {
    const cache = {}
    const findValue = (responses, rId) => {
      if (rId in cache) {
        return cache[rId]
      } else {
        const result = responses.find((r) => r.id === rId).numeric_value
        cache[rId] = result
        return result
      }
    }
    return findValue
  }

  responseFetch = this.memoizeResponse()

  getVotes = () => {
    try {
      const { currentTabIdx, selectedRatings } = this.state
      const { collection } = this.props

      const currentTab = collection.children[currentTabIdx]
      const currentVotesIds = selectedRatings[currentTab.id]
      if (!currentVotesIds) return []

      const votes = Object.entries(currentVotesIds).map(([qId, rId]) => {
        const resps = currentTab.questions.find((q) => q.id === qId).responses
        const value = this.responseFetch(resps, rId)
        return value
      })
      return votes
    } catch (error) {
      console.log(error)
      return []
    }
  }

  getOverallScore = () => {
    const { currentTabIdx } = this.state
    const { collection } = this.props
    if (
      !collection ||
      !collection.children ||
      !collection.children[currentTabIdx]
    )
      return 0

    const votes = this.getVotes()

    const sum = votes.reduce((prev, curr) => prev + curr, 0)
    const result = sum / votes.length
    return result.toFixed(1)
  }

  getWeightedScore = () => {
    const { currentTabIdx } = this.state
    const { collection } = this.props
    if (
      !collection ||
      !collection.children ||
      !collection.children[currentTabIdx]
    )
      return 0

    const weights = this.props.collection.children[currentTabIdx].questions
      .sort(questionsSortFunc)
      .map(({ weight }) => weight)

    const votes = this.getVotes()
    // const votes = Object.values(currentVotes)
    const result = votes.reduce(
      (prev, curr, idx) => prev + curr * weights[idx],
      0
    )
    return result.toFixed(1)
  }

  onShareUrlClick = () => {
    copy(window.location.href)
      .then(() => {
        notify.show('Copied share link to clipboard!', 'success', 1000)
      })
      .catch(() => {
        notify.show('Failed to copy share link to clipboard!', 'warning', 1000)
      })
  }

  onResultClick = () => {
    const { history, location } = this.props
    history.push(`${getParticipateURL(location.pathname)}/result`)
  }

  render() {
    const {
      currentTabIdx,
      viewMode,
      selectedRatings,
      isShareDialogOpen,
      hasSessionEnded,
      isCongratulationsDialogOpen,
      displayCommentsOption,
      availableTabs,
    } = this.state

    const {
      collection,
      user,
      history,
      location,
      comments,
      collectionLoading,
    } = this.props
    const { title, subtitle, custom_attr_1 } = collection || {}

    const collectionChildren = collection ? collection.children : []
    const currentTab = collectionChildren.length
      ? collectionChildren[currentTabIdx]
      : {}
    const currentVotes = selectedRatings[currentTab.id] || {}
    // const disabledFooterButtonsIdxs = Object.keys(currentVotes).length !== data.length ? [1] : []

    const itemNum = currentTabIdx + 1
    const lastItem = itemNum === collectionChildren.length
    const itemCountText = `Please rate item ${itemNum} of ${
      collectionChildren.length || itemNum
    } using the factors below:`
    const itemTitle = currentTab ? currentTab.title : ''
    const itemDescription = currentTab ? currentTab.description : ''
    const itemCustomAttr1 = currentTab ? currentTab.custom_attr_1 : ''

    const key = Object.entries(currentVotes).reduce(
      (pr, [key, cr]) => (pr += cr),
      ''
    )
    const overall = this.getOverallScore()
    const weighted = this.getWeightedScore()
    const isDisabled = hasSessionEnded

    const end_on = collection
      ? moment(collection.end_on).format('MMM DD, YYYY')
      : ''
    const congratulationsText = `You can still edit your answers and\n
                                participate in discussions until the session ends on ${end_on}\n`
    const congratulationsTitleElem = (
      <Fragment>
        <p className="title">Thank you for your continued participation!</p>
      </Fragment>
    )
    const commentsCount =
      comments &&
      currentTab &&
      comments[currentTab.id] &&
      comments[currentTab.id].length

    // console.log('selectedRatings', selectedRatings);
    return (
      <Prioritize
        onViewModeChange={this.onViewModeChange}
        mode={viewMode}
        step={3}
        onNavClick={this.onFooterButtonClick}
        collection={collection}
        isHeaderChildrenBottom={true}
      >
        <Header>
          <div className="prioritize__header-modes">
            <HeaderViewsToggle
              onViewModeChange={this.onViewModeChange}
              viewMode={viewMode}
            />
          </div>

          <div className="prioritize__header-menu">
            <Timer endTime={collection && collection.end_on} />
          </div>
          <h1>{'Prioritize'}</h1>
        </Header>

        <DialogModalWindow
          isOpen={user && user.display_name && isShareDialogOpen}
          title={`Almost there, ${user && user.display_name}!`}
          onCancel={() => this.setState({ isShareDialogOpen: false })}
          cancelBtn={false}
          confirmBtn={false}
        >
          <p>Copy and share this link via email to spread the word</p>
          <div className="share">
            <div className="url" onClick={this.onShareUrlClick}>
              {window.location.href}
            </div>
            <Button className="btn-primary" onClick={this.onShareUrlClick}>
              Copy
            </Button>
          </div>
          <small>
            Anyone inside and/or outside your organization can access your POPin
            with this link
          </small>
        </DialogModalWindow>

        {collectionLoading ? (
          <LoadingAndPulse size={10} color="#B8BAC7" whatIsLoading="activity" />
        ) : (
          <div className="participate">
            <BlueHeader subtitle={subtitle} title={title} />

            <BubbleTabs
              availableIdxs={availableTabs}
              currentTabIdx={currentTabIdx}
              tabs={collectionChildren}
              onClick={this.handleClick}
            />
            <div className="item-header">
              <div className="item-count">{itemCountText}</div>
              <h2>
                {itemNum}. {itemTitle}
              </h2>
              <ItemDetails value={itemDescription} />
            </div>

            <Content
              title={itemTitle}
              weighted={weighted}
              overall={overall}
              customAttr1Label={custom_attr_1}
              customAttr1Value={itemCustomAttr1}
            >
              {viewMode === 'creative' ? (
                <CreativeView
                  key={key}
                  currentTabIdx={currentTabIdx}
                  disabled={isDisabled}
                  selectedNums={currentVotes}
                  onClick={this.onRatingClick}
                />
              ) : (
                <TabularView
                  key={key}
                  currentTabIdx={currentTabIdx}
                  disabled={isDisabled}
                  selectedNums={currentVotes}
                  onClick={this.onRatingClick}
                />
              )}
            </Content>
          </div>
        )}

        <Footer>
          <FooterButtons
            onClick={this.onFooterButtonClick}
            lastStep={lastItem}
            currentTabIdx={currentTabIdx}
            disabled={isDisabled}
            displayCommentsOption={displayCommentsOption}
            commentsCount={commentsCount}
          />
        </Footer>

        <Comments
          isShowComments={!!displayCommentsOption}
          isNewCommentOpen={displayCommentsOption === 'add'}
          setDisplayOption={this.onComment}
          collectionId={currentTab?.id}
        />

        <ExampleFactors />

        <DialogModalWindow
          isOpen={isCongratulationsDialogOpen}
          title={congratulationsTitleElem}
          onCancel={() => {
            this.setState({ isCongratulationsDialogOpen: false })
          }}
          onConfirm={() => {
            history.push(`${location.pathname}/result`)
          }}
          confirmBtnText="View Results"
          cancelBtnText="Continue Participation"
        >
          {splitText(congratulationsText, '\n')}
        </DialogModalWindow>
      </Prioritize>
    )
  }
}

const ItemDetails = ({ value }) => {
  const [isOpen, setIsOpen] = useState(false)
  if (!value) {
    return <></>
  }
  return (
    <div style={{ marginLeft: 20 }}>
      <a
        href="/#"
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(!isOpen);
        }}
      >
        {isOpen ? 'Hide' : 'Expand'} Details{' '}
        <i className="material-icons">
          {isOpen ? 'expand_less' : 'expand_more'}
        </i>
      </a>
      {isOpen && <p>{value}</p>}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    userError: state.user.error,
    collection: state.prioritize.collection,
    comments: state.prioritize.comments,
    currentFactors: state.prioritize.currentFactors,
    collectionLoading: state.prioritize.collectionLoading,
  }
}

export default withRouter(
  connect(mapStateToProps, {
    sessionCheck,
    showDialog,
    getComments,
    getCurrentCollection,
  })(Participate)
)
